import gsap from "gsap";
import { observer } from "./shared";

const
section_3 = document.getElementById("section-3"),
section_4 = document.getElementById("section-4"),
section_5 = document.getElementById("section-5"),
section_6 = document.getElementById("section-6");

observer.observe(section_3);
observer.observe(section_4);
observer.observe(section_5);
observer.observe(section_6);
